var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "confirmModal",
      attrs: {
        title: "Genial!",
        "hide-footer": "",
        "hide-header-close": "",
        centered: "",
        "no-close-on-backdrop": ""
      }
    },
    [
      _vm.state === _vm.DRAFT
        ? _c("h6", [
            _vm._v("Se ha guardado el borrador " + _vm._s(_vm.dntCode))
          ])
        : _vm.isMotherDocument
        ? _c("h6", [
            _vm._v(
              " Excelente, has realizado el registro del documento y el número de ingreso es: "
            ),
            _c("b", [_vm._v(_vm._s(_vm.dntCode))]),
            _vm._v(
              ". Se ha creado el expediente con este mismo número de ingreso. "
            )
          ])
        : !_vm.isMotherDocument
        ? _c("h6", [
            _vm._v(
              " Excelente, has realizado el registro del documento y el número de ingreso es: "
            ),
            _c("b", [_vm._v(_vm._s(_vm.dntCode))]),
            _vm._v(". Se ha asociado correctamente al expediente "),
            _c("b", [_vm._v(_vm._s(_vm.motherDocNumber))]),
            _vm._v(". ")
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _c(
            "b-button",
            { attrs: { variant: "success" }, on: { click: _vm.closeModal } },
            [_vm._v(" Ok ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }